module.exports = __webpack_public_path__ + "img/88.7da23d9d.jpg";